module.exports = __webpack_public_path__ + "static/offer-design-time-a4dd42f74eec875daaa1a1c5845b408b.jpg";